import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import CountdownTimer from '../CountdownTimer/CountdownTimer';

function TaskSelection({ onAddTask, onSubmitRequest, onNavigateToAddTask, onNavigateToRequest }) {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      p: 2,
      gap: 4
    }}>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, width: '100%', maxWidth: 400 }}>
        {/* Add Task Button */}
        <Paper 
          elevation={0}
          sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            backgroundColor: '#EEF2FF', // 現代感淡藍色背景
            border: '1px solid #E0E7FF',
            transition: 'transform 0.2s, box-shadow 0.2s',
            '&:active': {
              transform: 'scale(0.98)'
            }
          }}
        >
          <Button
            fullWidth
            onClick={onNavigateToAddTask}
            sx={{
              height: 'auto',
              minHeight: 110,
              py: 2.5,
              px: 3,
              color: '#4F46E5', // 深靛藍色文字
              textTransform: 'none',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: '#E0E7FF'
              }
            }}
            startIcon={<span style={{ fontSize: '2.5rem', marginRight: '12px' }}>📝</span>}
          >
            <Box sx={{ textAlign: 'left' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5, lineHeight: 1.2 }}>
                Add Task
              </Typography>
              <Typography variant="body2" sx={{ color: '#6366F1', fontWeight: 500, lineHeight: 1.4 }}>
                Create to-do and set reminders for others
              </Typography>
            </Box>
          </Button>
        </Paper>

        {/* Submit Request Button */}
        <Paper 
          elevation={0}
          sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            backgroundColor: '#FDF4FF', // 現代感淡紫色背景
            border: '1px solid #FAE8FF',
            transition: 'transform 0.2s, box-shadow 0.2s',
            '&:active': {
              transform: 'scale(0.98)'
            }
          }}
        >
          <Button
            fullWidth
            onClick={onNavigateToRequest}
            sx={{
              height: 'auto',
              minHeight: 110,
              py: 2.5,
              px: 3,
              color: '#C026D3', // 深紫色文字
              textTransform: 'none',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: '#FAE8FF'
              }
            }}
            startIcon={<span style={{ fontSize: '2.5rem', marginRight: '12px' }}>📋</span>}
          >
            <Box sx={{ textAlign: 'left' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5, lineHeight: 1.2 }}>
                Submit Request
              </Typography>
              <Typography variant="body2" sx={{ color: '#D946EF', fontWeight: 500, lineHeight: 1.4 }}>
                Submit leave or other requests
              </Typography>
            </Box>
          </Button>
        </Paper>

        {/* Embedded CountdownTimer Component */}
        <Box sx={{ width: '100%', mt: 1 }}>
          <CountdownTimer />
        </Box>
      </Box>
    </Box>
  );
}

export default TaskSelection;